<template>
   <div class="loading-dot-wrapper">
      <div class="loading-dot">
         <span class="loading-dot-outside"></span>
      </div>
   </div>
</template>

<script>
export default {
   name: 'loading-dots',
}
</script>